import React from 'react';
import DealerAd from '../DealerAd/DealerAd';

const App: React.FC = () => {
  if (!window.location.search) {
    return null;
  }
  const params = new URLSearchParams(window.location.search);

  return (
    <DealerAd
      translationVersion={window.__DEALER_T_VERSION__}
      realEstateId={params.get('realEstateId') || ''}
      userGuid={params.get('userGuid') || ''}
      biClientId={params.get('biClientId') || ''}
      biClientIdSigned={params.get('biClientIdSigned') || ''}
      withCloseButton={!!params.get('withCloseButton')}
    />
  );
};

export default App;
